var juuls = juuls || {};

juuls.news = {
    _row: null,
    _module: {},
    endpoint: '/system/data/articles',
    init: () =>{
        const domRow = document.querySelector('.js-juuls-news-row');
        if(domRow != null){
            juuls.news._row = domRow;
            juuls.news._module = JSON.parse(domRow.dataset.settings);
            juuls.news.bindEvents();
            juuls.news.getArticles();
        }
        
    },
    bindEvents: () =>{
        juuls.news._row.addEventListener('filters:changed', () =>{
            juuls.news.pagination.resetPageNumber();
            juuls.news.getArticles();
        });
        juuls.news._row.addEventListener('pagination:created', () =>{
            document.querySelectorAll('.js-juuls-news-pagination-item').forEach((link) =>{
                link.addEventListener('click', (event) =>{
                    event.preventDefault();
                    juuls.news.pagination.setPageNumber(event);
                });
            });
            document.querySelector('.js-juuls-pagination-prev').addEventListener('click',(event) =>{
                event.preventDefault();
                if(!event.target.classList.contains('disabled')){
                    juuls.news.pagination.prev();
                }
                
            });
            document.querySelector('.js-juuls-pagination-next').addEventListener('click',(event) =>{
                event.preventDefault();
                if(!event.target.classList.contains('disabled')) {
                    juuls.news.pagination.next();
                }
            });
        });
        
    },
    getFilters: () =>{
        const selectedFilters = document.querySelectorAll('.js-e-news-filter-option.active');
        return Array.from(selectedFilters).map(f => `${f.dataset.filter}`);
    },
    getArticles: async () =>{
        const selectedFilters = juuls.news.getFilters();
        const pageCount = juuls.news.pagination.getPageCount();
        const itemsPerList = parseInt(juuls.news._module.Settings.NewsParagraphCustomNumberPerList);
        const currentPage = juuls.news.pagination.getCurrentPage();
        let url = `${juuls.news.endpoint}?pages=${pageCount}&items=${itemsPerList}&current=${currentPage}`;
        if(selectedFilters.length && !selectedFilters.includes('*')){
            selectedFilters.forEach((selectedFilter, index) => {
                url = `${url}&filters=${selectedFilter}`;
            })
        }
        juuls.news.loader(true);
        const request = await fetch(url);
        const json = await request.json();
        const result = [];
        json.articles.forEach((article) =>{
            result.push(article.NewItemHtml);
        });
        juuls.news._row.innerHTML = result.join('');
        juuls.news.pagination.filter(json);
        juuls.news.loader(false);
    },
    loader: (show) =>{
      const loader = document.querySelector('.js-juuls-news-loading-overlay');
      if(show === true){
          loader.classList.add('is-loading');
      } else{
          loader.classList.remove('is-loading');
      }
    },
    pagination: {
        _current: 1,
        next: () =>{
            juuls.news.pagination._current++;
            juuls.news.getArticles();
        },
        prev: () =>{
            juuls.news.pagination._current--;
            juuls.news.getArticles();
        },
        getCurrentPage: () =>{
          return juuls.news.pagination._current;  
        },
        getPageCount: () =>{
            const hiddenCode = document.querySelector('.js-e-news-pagination-list-dw');
            if(hiddenCode !== null){
                return hiddenCode.querySelectorAll('a').length;
            }
            return 0;
        },
        setPageNumber: (event) =>{
            const pageNum = event.target.dataset.page;
            juuls.news.pagination._current = parseInt(pageNum);
            juuls.news.getArticles();
        },
        filter: (data) =>{
            const itemsPerList = parseInt(juuls.news._module.Settings.NewsParagraphCustomNumberPerList);
            const totalPages = Math.ceil(data.totalPages / itemsPerList);
            const currentPage = Math.max(1, Math.min(data.currentPage, totalPages));
            const startIndex = (currentPage - 1) * itemsPerList;
            const endIndex = Math.min(startIndex + itemsPerList - 1, totalPages - 1);
            const lastPage = endIndex + 1;
            const links = document.querySelectorAll('.js-juuls-news-pagination-item');
            const prevLink = document.querySelector('.js-juuls-pagination-prev');
            const nextLink = document.querySelector('.js-juuls-pagination-next');

            const activeLink = document.querySelector('.js-e-news-pagination-item.active');
            if(activeLink !== null){
                activeLink.classList.remove('active');
            }
            
            if(data.currentPage > 1 && lastPage !== 1){
                prevLink.classList.remove('disabled');
                
            } else{
                prevLink.classList.add('disabled');
            }
            

            if(data.currentPage < data.pageCount && lastPage !== 1){
                nextLink.classList.remove('disabled');

            } else{
                nextLink.classList.add('disabled');
            }
            
            links.forEach((link) =>{
                if(parseInt(link.dataset.page) > lastPage){
                    link.closest('.js-e-news-pagination-item').classList.add('d-none');
                } else{
                    link.closest('.js-e-news-pagination-item').classList.remove('d-none');
                }
                if(parseInt(link.dataset.page) === currentPage){
                    link.closest('.js-e-news-pagination-item').classList.add('active');
                }
            })
        },
        resetPageNumber: () =>{
            juuls.news.pagination._current = 1;
        },
    }
}